export default __webpack_public_path__ + "static/media/avatar-1577909_960_720.22d7f1c8.png";